// extracted by mini-css-extract-plugin
export default {"hideTooltip":"o--z","fadeIn":"p--z","delay":"q--z","recommendedSizeTooltip":"r--z"};